import { ICreateSRMembershipPageModel } from '../../../../../../models/interfaces/Membership/SecurityResponse/CreateSRMembershipPageModel';

export const checkFamilyMembersFormVisible = (
  values: ICreateSRMembershipPageModel,
) =>
  values &&
  values.membershipPlanId &&
  values.membershipPlanId.maxMembersPerPlan > 1;
